import { useBoolean } from '@dreryk/react-common';

import { OnlinePaymentsRemoveIntegrationModal } from './OnlinePaymentsRemoveIntegrationModal';

type OnlinePaymentsRemoveIntegrationModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type OnlinePaymentsRemoveIntegrationModalOpenerProps = {
   readonly children: (renderProps: OnlinePaymentsRemoveIntegrationModalOpenerRenderProps) => JSX.Element;
};

export const OnlinePaymentsRemoveIntegrationModalOpener = (
   props: OnlinePaymentsRemoveIntegrationModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <OnlinePaymentsRemoveIntegrationModal onCancel={closeModal} /> : null}
      </>
   );
};
